import { Component, OnInit } from '@angular/core';
import { CategoriaService } from '../../services/categoria.service';
import { ConsorciosService } from '../../services/consorcios.service';
import { Categoria } from '../../model/categoria';
import { Consorcio } from '../../model/consorcio';

@Component({
  selector: 'app-categoria-articulo-list',
  templateUrl: './categoria-articulo-list.component.html',
  styleUrls: ['./categoria-articulo-list.component.css']
})
export class CategoriaArticuloListComponent implements OnInit {

  public categoriaSeleccionada: Categoria;

  public modoEdicion: boolean = false;
  public categorias: Categoria[];
  public consorcio: Consorcio;
  public consorcios: Consorcio[];
  public query: any;
public filtro:string;
  constructor(
    private categoriaService: CategoriaService,
    private _consorcioService: ConsorciosService
  ) { }

  ngOnInit() {
     this.filtro = "";
    this.categorias = [];
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.cargarConsorcios();
  }

  cargarConsorcios() {
    this.query = { "email": sessionStorage.getItem("login") };
    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err._body);
      });
  }

  refrescarCategorias() {
    if (this.consorcio === null) {
      return;
    }
    this.categoriaService.getCategorias(this.consorcio)
      .subscribe(
      data => this.categorias = data,
      err => {
        console.log(err);
      });
  }

  editarRegistro(_categoria: Categoria) {
    this.categoriaSeleccionada = _categoria;
    this.modoEdicion = true;
  }


  agregarRegistro() {
    if (this.consorcio === undefined) {
      return;
    }
    this.categoriaSeleccionada = null;
    this.modoEdicion = true;
  }

  regresar() {
    this.refrescarCategorias();
    this.modoEdicion = false;
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/categoria-articulo-list/categoria-articulo-list.component.ts